import { action, makeAutoObservable } from 'mobx';
import { ChangeEvent } from 'react';
import { SdkStaff } from 'src/AppState/sdk/staff';

export class EventShortSettingsState {
    constructor(
        private readonly sdkStaff: SdkStaff,
        private readonly eventId: number
    ) {
        makeAutoObservable(this);
    }

    @action onActiveChangeHandler = (e: ChangeEvent<HTMLSelectElement>): void => {
        const option = e.currentTarget.value;
        this.sdkStaff.updateEvent({ event_id: this.eventId, requestBody: { active: option === '1' } });
    };

    @action onDisplayChangeHandler = (e: ChangeEvent<HTMLSelectElement>): void => {
        const option = e.currentTarget.value;
        this.sdkStaff.updateEvent({ event_id: this.eventId, requestBody: { display: option === '1' } });
    };
}
